const videos = [
  {
    title: '独家揭秘：某知名艺人后台耍大牌全程录像曝光',
    duration: '15:28',
    img: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20corridor%20with%20dramatic%20lighting%2C%20mysterious%20entertainment%20venue%20backstage%2C%20cinematic%20mood%2C%20crimson%20accents%2C%20editorial%20style&width=600&height=340&seq=media-01-91hl&orientation=landscape',
    views: '289万',
    tag: '独家',
  },
  {
    title: '网红直播意外事故全记录：那些被永久封禁的名场面',
    duration: '22:41',
    img: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20room%20with%20error%20screen%2C%20dramatic%20red%20alert%20lighting%2C%20mysterious%20digital%20atmosphere%2C%20cinematic%20style&width=600&height=340&seq=media-02-91hl&orientation=landscape',
    views: '456万',
    tag: '热门',
  },
  {
    title: '娱乐圈大佬饭局对话偷拍：内容劲爆尺度极大',
    duration: '08:55',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20private%20dining%20room%2C%20mysterious%20atmosphere%20with%20candlelight%2C%20dramatic%20shadows%2C%20cinematic%20editorial%20photography%2C%20crimson%20warm%20tones&width=600&height=340&seq=media-03-91hl&orientation=landscape',
    views: '672万',
    tag: '劲爆',
  },
  {
    title: '实拍某选秀节目录制现场：评委与选手激烈冲突',
    duration: '11:32',
    img: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20with%20empty%20judges%20panel%2C%20dramatic%20stage%20lighting%2C%20conflict%20atmosphere%2C%20cinematic%20mood%20with%20crimson%20and%20amber%20accents&width=600&height=340&seq=media-04-91hl&orientation=landscape',
    views: '198万',
    tag: '现场',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🎬 精彩视频
          </h2>
          <p className="text-sm text-foreground-600">
            独家爆料的视频内容，第一手现场资料尽在91黑料
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {videos.map((video, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={video.img}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-accent-950">
                  {video.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md text-xs bg-black/60 text-white backdrop-blur-sm">
                  {video.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}次播放
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}